import { z } from 'zod';
import { idSchema, softDelete, timestamps } from './utility';

export const clientSchema = z.object({
  id: idSchema,
  uuid: z.string(),
  ref_id: z.string().nullable(),
  party_type_id: idSchema.nullable(),
  tax_number: z.string().nullable(),
  tax_number_root: z.string().nullable(),
  name: z.string().nullable(),
  long_name: z.string().nullable(),
  default_tone_of_voice: z.enum(['formal', 'informal']),
  default_legal_relationship_id: idSchema,
  default_claim_type_id: idSchema,
  client_data: z.unknown(),
  pwc_syncs: z.array(z.unknown()),
  uses_credits: z.boolean().default(false),
  credits: z.array(z.object({
    remaining: z.number(),
    used: z.number(),
    currency_iso: z.string(),
  })),
  ...timestamps,
  ...softDelete,
});
export type Client = z.infer<typeof clientSchema>;
